import logo from "../../assets/Logo/yellow-logo.png";
export default function Footer() {
  return (
    <footer className="bg-[#162456] text-white py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <img src={logo} alt="l" className="w-48" />
            </div>
            <p className="text-sm text-primary-foreground/70">
              Premium chemistry coaching from IIT Kanpur mentor
            </p>
          </div>

          {/* Programs */}
          <div>
            <h4 className="font-semibold mb-4">Programs</h4>
            <ul className="space-y-2 text-sm text-primary-foreground/70">
              <li>
                <a
                  href="#"
                  className="hover:text-primary-foreground transition"
                >
                  IIT JAM
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="hover:text-primary-foreground transition"
                >
                  IIT JEE
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="hover:text-primary-foreground transition"
                >
                  GATE
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="hover:text-primary-foreground transition"
                >
                  NET
                </a>
              </li>

              <li>
                <a
                  href="#"
                  className="hover:text-primary-foreground transition"
                >
                  NEET
                </a>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="font-semibold mb-4">Resources</h4>
            <ul className="space-y-2 text-sm text-primary-foreground/70">
              <li>
                <a
                  href="#"
                  className="hover:text-primary-foreground transition"
                >
                  Blog
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="hover:text-primary-foreground transition"
                >
                  Study Materials
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="hover:text-primary-foreground transition"
                >
                  FAQ
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold mb-4">Contact</h4>
            <ul className="space-y-2 text-sm text-primary-foreground/70">
              <li>Email: machineacademy08@gmail.com</li>
              <li>Phone: +91 7049972204</li>
              <li>Follow us on social media</li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-primary-foreground/20 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center text-sm text-primary-foreground/60">
            <p>
              &copy; 2025 Machine Academy. Made by{" "}
              <a href="www.sanamio.tech">Sanamio Tech</a>.
            </p>
            <div className="flex gap-6 mt-4 md:mt-0">
              <a href="#" className="hover:text-primary-foreground transition">
                Privacy Policy
              </a>
              <a href="#" className="hover:text-primary-foreground transition">
                Terms of Service
              </a>
              <a href="#" className="hover:text-primary-foreground transition">
                Contact Us
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
